<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">{{ $t("TAX_GROUPS.TAX_GROUPS_LIST") }}</h3>
            </div>
            <div class="col-6 text-right">
              <base-button
                type="primary"
                icon
                size="sm"
                @click="addTaxGroup()"
                v-if="$currentUserCan($permissions.PERM_CREATE_TAXES)"
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">{{
                  $t("TAX_GROUPS.ADD_TAX_GROUP")
                }}</span>
              </base-button>
              <notification-subscription
                v-if="$currentUserCan($permissions.PERM_VIEW_TAXES)"
                :objectType="'taxGroups'"
                :events="{
                  CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>

        <tax-group-list-table />
      </card>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import TaxGroupListTable from "./partials/TaxGroupListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    TaxGroupListTable,
    NotificationSubscription,
    [Button.name]: Button,
  },

  mixins: [],

  computed: {},

  watch: {},

  methods: {
    addTaxGroup() {
      this.$router.push({ name: "Add TaxGroup" });
    },
  },
};
</script>
